var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommunication(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1382)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34 44.9119L24 39.1429V27.6049L34 21.8369L44 27.6049V39.1429L34 44.9119Z",
    fill: "url(#paint0_linear_1_1382)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 44.9119L4 39.1429V27.6049L14 21.8369L24 27.6049V39.1429L14 44.9119Z",
    fill: "url(#paint1_linear_1_1382)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 27.6048L14 21.8368V10.2978L24 4.52783L34 10.2978V21.8348L24 27.6048Z",
    fill: "url(#paint2_linear_1_1382)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 44.912L24 39.143M34 44.912L44 39.143V27.605M34 44.912V33.374M24 39.143V27.604M24 39.143L14 44.912M34 33.374L24 27.604M34 33.374L44 27.604L34 21.836M24 27.604L34 21.836M24 27.604L14 21.836M24 27.604L14 33.374V44.912M14 44.912L4 39.143V27.605L14 33.375M34 21.836V10.298M14 21.836L4 27.604M14 21.836L24 27.605V16.067M14 21.836V10.298M14 10.3L24 4.53003L34 10.3L24 16.069L14 10.3Z",
    stroke: "#18181B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_1382",
    x1: 24,
    y1: 44.9119,
    x2: 24,
    y2: 4.52992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFFB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3FFAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_1382",
    x1: 24,
    y1: 44.9119,
    x2: 24,
    y2: 4.52992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFFB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3FFAF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_1382",
    x1: 24,
    y1: 44.9118,
    x2: 24,
    y2: 4.52983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFFB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3FFAF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1382"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0 0.689941)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunication);
export default __webpack_public_path__ + "static/media/communication.e61b45a184cb86793b74eeae25325879.svg";
export { ForwardRef as ReactComponent };